/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdown200,
  GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdown401,
  GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdown404,
  GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdown500,
  GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdownPathParams,
  GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdownQueryParams,
  GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1PersonPersonidSharedEnrollmentDocumentsDropdownPathParamsSchema =
  z.object({
    personId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdownPathParams>;

export const getApiV1PersonPersonidSharedEnrollmentDocumentsDropdownQueryParamsSchema =
  z
    .object({
      classStudentId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonPersonidSharedEnrollmentDocumentsDropdown200Schema =
  z.array(
    z.lazy(() => dropDownRepositoryResponseSchema),
  ) as unknown as ToZod<GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonPersonidSharedEnrollmentDocumentsDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdown401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonPersonidSharedEnrollmentDocumentsDropdown404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdown404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonPersonidSharedEnrollmentDocumentsDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdown500>;

export const getApiV1PersonPersonidSharedEnrollmentDocumentsDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonPersonidSharedEnrollmentDocumentsDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonPersonidSharedEnrollmentDocumentsDropdownQueryResponse>;
